import { v4 as uuidv4 } from "uuid";

export type DeviceIdScope = "mobile" | "desktop";

/**
 * ID estável por navegador, com escopos separados para mobile e desktop.
 * Assim a mesma conta pode ter sessão no celular e no PC (login por senha + QR),
 * cada uma com um deviceId distinto — alinhado ao backend (um MOBILE + um DESKTOP por conta).
 */
export async function getDeviceId(scope: DeviceIdScope = "desktop"): Promise<string> {
  const scopedKey = `device_id:${scope}`;

  const saved = await buscarIdentidade(scopedKey);
  if (saved) return saved;

  const legacy = await buscarIdentidade("device_id");

  if (legacy) {
    await salvarIdentidade(scopedKey, legacy);
    await removerIdentidade("device_id");
    return legacy;
  }

  const id = uuidv4();
  await salvarIdentidade(scopedKey, id);
  return id;
}

function abrirIndexedDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("DeviceIdentityDB", 1);
    request.onupgradeneeded = () => {
      request.result.createObjectStore("identidade", { keyPath: "chave" });
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function salvarIdentidade(chave: string, valor: string) {
  const db = await abrirIndexedDB();
  const tx = db.transaction("identidade", "readwrite");
  tx.objectStore("identidade").put({ chave, valor });
  return tx.oncomplete;
}

async function removerIdentidade(chave: string) {
  const db = await abrirIndexedDB();
  const tx = db.transaction("identidade", "readwrite");
  tx.objectStore("identidade").delete(chave);
  return tx.oncomplete;
}

async function buscarIdentidade(chave: string): Promise<string | null> {
  const db = await abrirIndexedDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction("identidade", "readonly");
    const request = tx.objectStore("identidade").get(chave);
    request.onsuccess = () => resolve(request.result?.valor || null);
    request.onerror = () => reject(request.error);
  });
}
